import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import { useApi } from "../../../../hooks/useApi";
import Blank from "../../../DefaultStyles/Blank";
import Loader from "../../../DefaultStyles/Loader";
import { Textarea } from "../../../Input/Textarea";
import AlertModal from "../../../Modal/AlertModal";
import DefaultModalLayout, {
  defaultModalType,
} from "../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import TargetContainer, {
  ModalLabel,
} from "../../Users/UserDetail/CommentModal/TargetContainer";
import CheckMassiveRegModal from "./CouponPointRegisterModal/CheckMassiveRegModal";
import GeneralRegister from "./CouponPointRegisterModal/GeneralRegister";
import MassiveRegister from "./CouponPointRegisterModal/MassiveRegister";
import PointTypeSelect from "./CouponPointRegisterModal/PointTypeSelect";
import PointValueInput from "./CouponPointRegisterModal/PointValueInput";
import RandomDeduct from "./CouponPointRegisterModal/RandomDeduct";

interface CouponRegisterModalProps {
  closeEvent: () => void;
  confirmEvent: () => void;
  isPoint?: boolean;
  userData?: {
    uid: string;
    name: string;
    nickname: string;
  };
}

export default function CouponPointRegisterModal({
  closeEvent,
  confirmEvent,
  isPoint,
  userData,
}: CouponRegisterModalProps) {
  const setModalType = useSetRecoilState(defaultModalType);
  const [memo, setMemo] = useState("");
  const [targetUid, setTargetUid] = useState(
    userData ? `${userData?.uid}_${userData?.name}_${userData?.nickname}` : ""
  );
  const [promId, setPromId] = useState<string | undefined>("");
  const [previewBtnClick, setPreviewBtnClick] = useState(false);
  const [confirmBtnClick, setConfirmBtnClick] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [check, setCheck] = useState({
    first: true,
    second: false,
    third: false,
    fourth: false,
  });
  const [couponCheck, setCouponCheck] = useState({
    first: true,
    second: false,
    third: false,
    fourth: false,
  });
  const [inputPointValue, setInputPointValue] = useState("");
  const [pointExpDate, setPointExpDate] = useState("날짜 선택");
  const [massiveData, setMassiveData] = useState<any[] | null>(null);
  const [checkMassiveReg, setCheckMassiveReg] = useState(false);

  const { response, error, loading } = useApi({
    method: "post",
    url: confirmBtnClick
      ? isPoint
        ? check?.fourth
          ? `point/reg/many`
          : check?.second
          ? `point/reg/value`
          : check?.third
          ? `point/delete`
          : `point/reg/promotion`
        : couponCheck?.fourth
        ? `coupon/many`
        : `coupon`
      : undefined,
    data:
      check?.fourth || couponCheck?.fourth
        ? {
            reg: massiveData,
            reason: memo,
          }
        : check?.third
        ? {
            uid: Number(targetUid?.split("_")[0]),
            amount: Number(inputPointValue?.replaceAll(",", "")),
            reason: memo,
          }
        : check?.second
        ? {
            uid: Number(targetUid?.split("_")[0]),
            promId: 12,
            reason: memo,
            value: Number(inputPointValue?.replaceAll(",", "")),
            expiredate: pointExpDate,
            isMany: 0,
          }
        : {
            uid: Number(targetUid?.split("_")[0]),
            promId: Number(promId),
            reason: memo,
            isMany: 0,
          },
  });

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      closeEvent();
      confirmEvent();

      if (isPoint) {
        toast.success(
          check?.third
            ? "포인트 지급이 취소되었습니다."
            : "포인트 지급이 완료되었습니다."
        );
      }
    }
  }, [closeEvent, confirmEvent, response, isPoint, check?.third]);

  useEffect(() => {
    if (error) {
      toast.error(error.data);
      setConfirmBtnClick(false);
    }
  }, [error]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      modalTitle={isPoint ? "포인트 지급/차감" : "쿠폰 지급"}
      confirmEvent={
        () =>
          check?.third
            ? setAlertModal(true)
            : (isPoint ? check?.fourth : couponCheck?.fourth)
            ? setCheckMassiveReg(true) // 일괄 지급 확인 모달
            : setConfirmBtnClick(true) // api 실행
      }
      confirmDisabled={
        ((isPoint ? check?.fourth : couponCheck?.fourth)
          ? false
          : !targetUid?.includes("_")) ||
        memo === "" ||
        ((isPoint ? check?.first : couponCheck?.first)
          ? promId === "" || !previewBtnClick
          : check?.third
          ? inputPointValue === ""
          : (isPoint ? check?.fourth : couponCheck?.fourth)
          ? !massiveData
          : inputPointValue === "" || pointExpDate === "날짜 선택")
      }
    >
      {/* 구분 */}
      <PointTypeSelect
        check={isPoint ? check : couponCheck}
        setCheck={isPoint ? setCheck : setCouponCheck}
        isPoint={isPoint}
      />

      {/* 대상 */}
      <>
        {!check?.fourth && !couponCheck?.fourth && (
          <ModalRow>
            <TargetContainer
              targetUid={targetUid}
              setTargetUid={setTargetUid}
            />
          </ModalRow>
        )}
      </>

      <>
        {(isPoint ? check?.first : couponCheck?.first) ? (
          // 일반 지급
          <GeneralRegister
            isPoint={isPoint}
            promId={promId}
            setPromId={setPromId}
            previewBtnClick={previewBtnClick}
            setPreviewBtnClick={setPreviewBtnClick}
          />
        ) : check?.third ? (
          // 임의 차감
          <RandomDeduct
            inputPointValue={inputPointValue}
            setInputPointValue={setInputPointValue}
          />
        ) : (isPoint ? check?.fourth : couponCheck?.fourth) ? (
          // 일괄 지급
          <MassiveRegister
            isPoint={isPoint}
            massiveData={massiveData}
            setMassiveData={setMassiveData}
          />
        ) : (
          // 임의 지급
          <>
            <PointValueInput
              inputPointValue={inputPointValue}
              setInputPointValue={setInputPointValue}
              pointExpDate={pointExpDate}
              setPointExpDate={setPointExpDate}
            />
          </>
        )}
      </>

      {/* 내용 */}
      <ModalLabel>
        {check?.fourth ? "지급 사유" : check?.third ? "차감 사유" : "내용"}
      </ModalLabel>
      <Blank blankHeight={0} marginHeight={16} />

      <Textarea
        placeholder={check?.third ? "차감 입력 (필수)" : "내용 입력 (필수)"}
        onChange={(e) => setMemo(e.target.value)}
        value={memo}
      />

      <Blank blankHeight={40} marginHeight={40} />

      <>
        {loading && <Loader />}

        {/* 포인트 임의 차감 체크 모달 */}
        {alertModal && (
          <AlertModal
            title={`${targetUid}님의
      ${inputPointValue} 포인트를 차감합니다.
      계속 하시겠습니까?`}
            confirmEvent={() => {
              setAlertModal(false);
              setConfirmBtnClick(true);
            }}
            cancelEvent={() => setAlertModal(false)}
          />
        )}

        {/* 일괄 지급 확인 모달 */}
        {checkMassiveReg && (
          <CheckMassiveRegModal
            massiveData={massiveData}
            closeEvent={() => setCheckMassiveReg(false)}
            confirmEvent={() => setConfirmBtnClick(true)}
            isPoint={isPoint}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

export const ValueContainer = styled.div`
  width: calc(100% - 106px);
  display: flex;
  align-items: center;
  gap: 10px;
`;
